import React, { ChangeEvent, useCallback, useState ,useEffect} from 'react';
import { useLocation , Link ,useNavigate} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import MembPasswdChngApi from 'Apis/MembPasswdChngApi';
import"Assets/css/MembFind.css";
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import FindPwEmlAthnNoSendApi from 'Apis/FindPwEmlAthnNoSendApi';
import useRecaptcha from 'Utils/useRecaptcha';
import { es } from 'date-fns/locale';
import ApiError from 'Utils/ApiError';
import ApiResultModal from 'Components/ApiResultModal';
import NickNameChngApi from 'Apis/NickNameChngApi';

const AppNickNameChngInputUi = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {isLoading,error,data: langData}:any = UseLangLstQuery( );
    let isAuthenticated: boolean = location.state?.isAuthenticated || false;
    // alert setting

    const [nickNameInputVal, setNickNameInputVal] = useState<string>("");
    const [nickNameErrorActive, setNickNameErrorActive] = useState<boolean>(false);
    const [nickNameSuccessActive, setNickNameSuccessActive] = useState<boolean>(false);
    const { getToken } = useRecaptcha();
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    const nickNameInputHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const nextValue = event.currentTarget.value.replace(/\s/g, "");
        setNickNameInputVal(nextValue);
        setNickNameErrorActive(false);
        setNickNameSuccessActive(false);
    };



    const NickNameChngFunc = async () => {
        if (nickNameInputVal.length < 1) {
            setNickNameErrorActive(true);
            setNickNameSuccessActive(false);
            return;
        }

        const token = await getToken('nick_change');
        NickNameChngApi(nickNameInputVal,token) // 입력된 닉네임 값 사용
        .then((resp) => {  
            if(resp.apiHdr.code == "COMM3013") {
                setNickNameErrorActive(true); // 에러 상태 활성화
                setNickNameSuccessActive(false); // 성공 상태 비활성화
            } else if(resp.apiHdr.code == "MEMB0000") {
              navigate(`/Connect/AppStrt`,{ state: { pageCd: "mypage" }, replace:true });
            } else {
                setNickNameErrorActive(false);
                setNickNameSuccessActive(false);
            }
            // token requested per-action
        });
    }
    return(
        <div className="loginInputWrap">
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
            confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
            app={"app"}
        />
        <Helmet>
            <title>BE@RBRICK CONNECT - Change Nickname</title>
        </Helmet>
        <div className="membJoinForm">
            <div className="membFindTitl membFindRsltTitl">
                <h1>{langData&&langData.MYPAGE_MAIN_MEMB_NICKNAME_TITL_00}</h1>
            </div>
            <div className="membFindRsltTxtWrap membFindPwRsltTxtWrap">
                <p>
                    {langData&&langData.MYPAGE_MAIN_MEMB_NICKNAME_DESC_00}
                </p>
            </div>
            <div className="membFindRsltUl membFindPwRsltUl">
                <ul className="pt30">
                    <li>
                        <input
                            type="text"
                            name='NickNameInput'
                            className='membJoinFormInput'
                            placeholder={`${langData&&langData.MYPAGE_MAIN_MEMB_NICKNAME_LBL_00}`}
                            id='nickNameInput'
                            value={nickNameInputVal}
                            onChange={nickNameInputHandler}
                            autoComplete="off"
                        />
                        <span className={
                            nickNameErrorActive ? "joinInputDesc active error" :
                            nickNameSuccessActive ? "joinInputDesc active success" : "joinInputDesc"
                        }>
                            {nickNameErrorActive
                                ? langData&&langData.MYPAGE_NICK_CHNG_FAIL_LBL_00
                                : nickNameSuccessActive
                                ? langData&&langData.MYPAGE_NICK_CHNG_SUCCESS_LBL_00
                                : ""
                            }
                        </span>
                    </li>
                </ul>
                <div className="nextBtnWrap">
                    <button onClick={NickNameChngFunc} className="loginBtn" >
                        {langData&&langData.MEMB_FIND_PASSWD_CHNG_BTN_00}
                    </button>
                </div>
            </div>
        </div>
        {/* reCAPTCHA provided at app root; tokens requested via useRecaptcha hook */}
        </div>
    )
}

export default AppNickNameChngInputUi;